/**
 * @author Rafaël Mindreau
 * Exposes cookies in JS
 */
export default (cookieName) => {
  const getAllCookies = () => document.cookie.split('; ');

  const getCookie = () => {
    const cookies = getAllCookies();
    const cookie = cookies.find((c) => c.indexOf(cookieName) !== -1);

    if (cookie) {
      return decodeURIComponent(cookie.split('=')[1]);
    }

    return null;
  };

  const setCookie = (value, expires = 7) => {
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + expires);
    document.cookie = `${cookieName}=${encodeURIComponent(value)}; expires=${expiresAt.toUTCString()}; path=/`;
  };

  const clearCookie = () => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

  return {
    getAllCookies,
    getCookie,
    setCookie,
    clearCookie,
  };
};
